@if (guia3.length != 0) {
<app-guia-component [GUIA_KEY]="GUIA_KEY" [data]="guia3"></app-guia-component>
} @else {
  <app-empty-state
    [message] = "guideThreeComponent()?.emptyStateMessage"
  ></app-empty-state>
  <br>
}
<div class="container-btn">
  <button type="button" (click)="handleGoBack()">{{guideThreeComponent()?.backButton}}</button>
</div>
